import React from "react";
import styled from "styled-components";
import ModalButton from "../ModalButton";
import { WarningCircleIcon, XIcon } from "@phosphor-icons/react";
import {
  StyledPopup,
  HeadCard,
  Content,
  IconWrap,
  Title,
  RequirementDescription,
  BottomCard,
} from "../MarcaBlancaRequirementsModal/styles";

const Detail = styled(RequirementDescription)`
  font-size: 15px;
  text-align: center;
`;

type Props = {
  open: boolean;
  color: string;
  title: string;
  detail: string;
  actionLabel: string;
  onClose: () => void;
  onAction: () => void;
};

const MarcaBlancaGenericErrorModal: React.FC<Props> = ({
  open,
  color,
  title,
  detail,
  actionLabel,
  onClose,
  onAction,
}) => {
  return (
    <StyledPopup
      open={open}
      modal
      closeOnDocumentClick={false}
      closeOnEscape={false}
      onClose={() => undefined}
    >
      <div className="container">
        <HeadCard>
          <XIcon
            size={24}
            color="#999999"
            style={{ cursor: "pointer" }}
            onClick={onClose}
          />
        </HeadCard>

        <Content>
          <IconWrap>
            <WarningCircleIcon size={56} weight="regular" color="#F5C518" />
          </IconWrap>
          <Title>{title}</Title>
          {detail && <Detail>{detail}</Detail>}
        </Content>

        <BottomCard>
          <ModalButton color={color} secondary={false} onClick={onAction}>
            {actionLabel}
          </ModalButton>
        </BottomCard>
      </div>
    </StyledPopup>
  );
};

export default MarcaBlancaGenericErrorModal;
